import { render } from "./ChatbotStep2.vue?vue&type=template&id=2d051874&scoped=true"
import script from "./ChatbotStep2.vue?vue&type=script&lang=js"
export * from "./ChatbotStep2.vue?vue&type=script&lang=js"

import "./ChatbotStep2.vue?vue&type=style&index=0&id=2d051874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d051874"]])

export default __exports__